import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19f251e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row gap-2 items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "Las contraseñas deben ser distintas", -1))
const _hoisted_4 = ["disabled"]

import { computed, ref } from "vue";
import Swal from "sweetalert2";

import { ChangePasswordData } from "@/services/auth/types";

import { AuthService } from "@/services/auth/AuthService";
import { useAuthStore } from "@/stores/auth";

import TextField from "@/components/atoms/TextField.vue"; // Asegúrate de importar TextField correctamente
import Modal from "../atoms/Modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordForm',
  props: {
  visible: {
    type: Boolean,
    defaul: false,
  },
},
  emits: ['update:visible'],
  setup(__props, { emit }) {





const oldPassword = ref("");
const newPassword = ref("");
const authStore = useAuthStore();
const shareholder = computed(() => authStore.user);

async function submitForm() {
  // Emitir evento con los datos de la contraseña actual y nueva
  const authService = new AuthService();
  const changePasswordData = new ChangePasswordData(
    shareholder?.value?.id ?? 1,
    newPassword.value,
    oldPassword.value
  );
  const { success } = await authService.changePassword(changePasswordData);

  if (!success) {
    Swal.fire(
      "Error!",
      "Ha surgido un error, intentelo nuevamente",
      "error"
    );
    emit("update:visible", false);
    return false;
  }
  Swal.fire("Listo!", "Contraseña actualizada correctamente", "success");
  emit("update:visible", false);
}

const bothBlank = computed(() => oldPassword.value?.trim() != '' &&  newPassword.value?.trim() )

const notSame = computed(() => oldPassword.value != newPassword.value || !bothBlank.value);

const allFilled = computed (() => 
  !!oldPassword.value && !!newPassword.value && notSame.value
);


return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Modal, {
      title: "Cambiar contraseña ",
      visible: __props.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = (e) => _ctx.$emit('update:visible', e))
    }, {
      default: _withCtx(() => [
        _createVNode(TextField, {
          class: "mt-2",
          name: "newPassword",
          model: oldPassword.value,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((oldPassword).value = $event)),
          type: "password",
          label: "Contraseña actual"
        }, null, 8, ["model"]),
        _createVNode(TextField, {
          class: "mt-2",
          name: "newPassword",
          model: newPassword.value,
          "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((newPassword).value = $event)),
          type: "password",
          label: "Nueva contraseña"
        }, null, 8, ["model"]),
        (!_unref(notSame))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_mdicon, {
                class: "text-red-500",
                name: "information"
              }),
              _hoisted_3
            ]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn",
          disabled: !_unref(allFilled),
          onClick: submitForm
        }, " Guardar ", 8, _hoisted_4)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})